import { render, staticRenderFns } from "./NavMenuView.vue?vue&type=template&id=0fdfb16a&scoped=true"
import script from "./NavMenuView.vue?vue&type=script&lang=js"
export * from "./NavMenuView.vue?vue&type=script&lang=js"
import style0 from "./NavMenuView.vue?vue&type=style&index=0&id=0fdfb16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdfb16a",
  null
  
)

export default component.exports